import React from "react"

export default ({props}) => {
	// console.log(props)

	const items = props.field_text_plain_long_repeater.map((item, key) => {
		let color = "inherit"
		if (item.substring(0,4) === "Gold") color = "#876930"
		if (item.substring(0,6) === "Silver") color = "#64696B"
		return <li key={key} style={{color: color}}>{item}</li>
	})

	return (
		<ul className="list-unstyled card-columns" style={{ columnCount: props.field_number_of_columns, marginLeft: 0, textAlign: "left" }}>
			{items}
		</ul>
	)
}
